import script from "./DeleteEventSimpleConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteEventSimpleConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./DeleteEventSimpleConfirmation.vue?vue&type=style&index=0&id=1a4f64b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a4f64b7"]])

export default __exports__